import React from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { Tag } from "antd";
import { useSessionsByUserId } from "../../api/SessionsAPI";
import { useNavigate } from "react-router-dom";
import {
  agGridThemeVars,
  agGridDefaultColDef,
  agGridPinnedActionsCellStyle,
} from "../../constants/agGridTheme";
import { StatusTag, SessionTypeTag } from "../common/SessionTags";
import { Card } from "antd";

const ReportsTable = ({ userId }) => {
  const navigate = useNavigate();
  const {
    data: sessions,
    isLoading: sessionsLoading,
    error: sessionsError,
  } = useSessionsByUserId(userId, {
    status: "completed",
    includeCompletedCount: true,
  });

  console.log("sessions", sessions);

  const generateReportRenderer = (params) => {
    return (
      <button
        onClick={() => navigate(`/reports/${params.data.id}`)}
        className="bg-primary hover:bg-primaryLight text-white text-xs font-medium py-1.5 px-3 rounded h-fit leading-none"
      >
        Generate Report
      </button>
    );
  };

  const sessionTypeRenderer = (params) => (
    <SessionTypeTag isCohortSession={params.data.cohort_id !== null} />
  );

  const statusRenderer = (params) => <StatusTag status={params.value} />;

  const columnDefs = [
    {
      headerName: "Name",
      field: "name",
      minWidth: 200,
      flex: 1,
      valueGetter: (params) =>
        params.data?.name || params.data?.display_name || "Untitled Session",
    },
    {
      headerName: "Started At",
      field: "created_at",
      valueFormatter: (params) => new Date(params.value).toLocaleString(),
      width: 160,
    },
    {
      headerName: "Status",
      field: "status",
      width: 120,
      cellRenderer: statusRenderer,
    },
    {
      headerName: "Session Type",
      field: "cohort_id",
      cellRenderer: sessionTypeRenderer,
      width: 130,
    },
    {
      headerName: "Competencies",
      field: "completed_count",
      width: 150,
    },
    {
      headerName: "Actions",
      cellRenderer: generateReportRenderer,
      sortable: false,
      filter: false,
      pinned: "right",
      width: 170,
      cellStyle: agGridPinnedActionsCellStyle,
    },
  ];

  if (sessionsLoading) {
    return <div>Loading...</div>;
  }

  if (sessionsError) {
    return <div>Error loading sessions: {sessionsError.message}</div>;
  }

  return (
    <Card className="w-full">
      <div
        className="ag-theme-alpine"
        style={{
          height: 400,
          width: "100%",
          ...agGridThemeVars,
        }}
      >
        <AgGridReact
          rowData={sessions}
          columnDefs={columnDefs}
          defaultColDef={agGridDefaultColDef}
          pagination={true}
          paginationPageSize={10}
          domLayout="autoHeight"
        />
      </div>
    </Card>
  );
};

export default ReportsTable;
